import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

export default function Observacoes({ texto }) {
  // Substitui \n simples por <br /> sem quebrar parágrafos duplos
  const textoFormatado = texto
    ? texto.replace(/\n/g, "  \n") // Markdown padrão: 2 espaços + \n = quebra de linha
    : "";

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeSanitize]}
    >
      {textoFormatado}
    </ReactMarkdown>
  );
}